// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".slider-box[data-v-61b5e0d3]{width:81%}[data-v-61b5e0d3].el-input-number{width:100%}[data-v-61b5e0d3].ivu-input{font-size:12px !important}.numbox[data-v-61b5e0d3]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-bottom:20px;font-size:12px}.numbox span[data-v-61b5e0d3]{width:80px;color:#999;font-size:12px}.c_row-item[data-v-61b5e0d3]{width:100%}", ""]);
// Exports
module.exports = exports;
